import { TranslateService } from '@ngx-translate/core';
import * as math from 'mathjs';

export class Sets {
  /**
   * 
   * @param a Array of strings
   * @param b Array of strings
   * @returns 
   */
  static difference(a: any[], b: any[]) { return this.setSort(new Set(Array.from(a).filter(x => !Array.from(b).includes(x)).concat(Array.from(b).filter(x => !Array.from(a).includes(x))))) }
  static intersection(a, b) { return new Set(Array.from(a).filter(x => !!Array.from(b).includes(x)).concat(Array.from(b).filter(x => !!Array.from(a).includes(x)))) }
  static union(a, b) { return new Set(Array.from(a).concat(Array.from(b))) }
  static isSubSet(a: any[], b: any[]) { return Array.from(new Set(a)).filter(x => !new Set(b).has(x)).length == 0 }
  static isSuperSet(a: any[], b: any[]) { return Array.from(new Set(b)).filter(x => !new Set(a).has(x)).length == 0 }
  static setSort(a: Set<string>): string[] { return Array.from(a).sort((a, b) => a.toLowerCase() < b.toLowerCase() ? -1 : 1) }
}

export class DeepRef {
    /**
   * Parse expression, split into items
   * @param expression
   * @returns {string[]}
   */
  static parseExpression(expression: string): string[] {
    expression = expression.replace(/\[(\w+)\]/g, ".$1");
    expression = expression.replace(/^\./, "");
    return expression.split(".");
  }

  /**
   * Get value by expression
   *
   * @param object
   * @param expression
   * @returns {any}
   */
   static getValue(object: any, expression:string | string[]): any {
    expression = typeof expression == 'string' ? expression.split('.') : expression;
    for (let i = 0, n = expression.length; i < n; ++i) {
      if (!object) {
        return;
      }
      const k = expression[i];
      if (!(k in object)) {
        return;
      }
      if (typeof object[k] === "function") {
        object = object[k]();
      } else {
        object = object[k];
      }
    }

    return object;
  }

  /**
   * Set value by expression
   *
   * @param object
   * @param value
   * @param expression
   */
  static setValue(object: any, value: any, expression: string[]) {
    let i;
    for (i = 0; i < expression.length - 1; i++) {
      object = object[expression[i]];
    }

    object[expression[i]] = value;
  }

  static comparator(a:object, b:object, expression:string | string[], sortType: string = 'string', reverse:boolean = false ){
    let r = reverse == false ? 1: -1; // sort inverter
    if(sortType == 'string') return this.getValue(a, expression).toLowerCase() < this.getValue(b, expression).toLowerCase() ? -1 * r : 1 * r;
    else return this.getValue(a, expression) < this.getValue(b, expression) ? -1 * r : 1 * r;
  }
}

export class Dates {
  static dateToDatePicker(date:string){
    let d = new Date(date);
    return {
      isRange:false,
        singleDate:{
          date : { 
            year : d.getFullYear(), 
            month: d.getMonth() + 1, 
            day: d.getDate()
          }
        }
    }
  }

  static dateToTimePicker(dueTime:string){
    if(!dueTime || dueTime.startsWith('23:59') ) { return null }
    return dueTime.slice(0, 5);
  }

  static durationQuartersToMinutes(time) {
    return +time.split(":")[0] * 60 + +time.split(":")[1];
  }

  static durationMinutesToQuarters(duration) {
    let d = Math.round(duration / 15);
    let h = Math.floor(duration / 60);
    let q = d % 4;
    if (q * 15 != 0) {
      return "0" + h.toString() + ":" + (q * 15).toString();
    } else {
      return "0" + h.toString() + ":00";
    }
  }

  static dueDateTimeFromTimePickers(date, time):string{
    return date + 'T' + (!!time ? time : '23:59') + ':00Z';
  }

  static formattedDate(date:string, options:Intl.DateTimeFormatOptions, locale:string = 'da-DK'){
    if(!date) return ''
    return new Intl.DateTimeFormat(locale, options).format(new Date(date))
  }

  static currentDateAsNumberString(){
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    }).format(new Date()).replace(/\D/g, '')
  }

  static dueTimes = [
    "00:00",
    "00:15",
    "00:30",
    "00:45",
    "01:00",
    "01:15",
    "01:30",
    "01:45",
    "02:00",
    "02:15",
    "02:30",
    "02:45",
    "03:00",
    "03:15",
    "03:30",
    "03:45",
    "04:00",
    "04:15",
    "04:30",
    "04:45",
    "05:00",
    "05:15",
    "05:30",
    "05:45",
    "06:00",
    "06:15",
    "06:30",
    "06:45",
    "07:00",
    "07:15",
    "07:30",
    "07:45",
    "08:00",
    "08:15",
    "08:30",
    "08:45",
    "09:00",
    "09:15",
    "09:30",
    "09:45",
    "10:00",
    "10:15",
    "10:30",
    "10:45",
    "11:00",
    "11:15",
    "11:30",
    "11:45",
    "12:00",
    "12:15",
    "12:30",
    "12:45",
    "13:00",
    "13:15",
    "13:30",
    "13:45",
    "14:00",
    "14:15",
    "14:30",
    "14:45",
    "15:00",
    "15:15",
    "15:30",
    "15:45",
    "16:00",
    "16:15",
    "16:30",
    "16:45",
    "17:00",
    "17:15",
    "17:30",
    "17:45",
    "18:00",
    "18:15",
    "18:30",
    "18:45",
    "19:00",
    "19:15",
    "19:30",
    "19:45",
    "20:00",
    "20:15",
    "20:30",
    "20:45",
    "21:00",
    "21:15",
    "21:30",
    "21:45",
    "22:00",
    "22:15",
    "22:30",
    "22:45",
    "23:00",
    "23:15",
    "23:30",
    "23:45",
  ];

  static durationTimes = [
    "00:15",
    "00:30",
    "00:45",
    "01:00",
    "01:15",
    "01:30",
    "01:45",
    "02:00",
    "02:15",
    "02:30",
    "02:45",
    "03:00",
    "03:15",
    "03:30",
    "03:45",
    "04:00",
    "04:15",
    "04:30",
    "04:45",
    "05:00",
    "05:15",
    "05:30",
    "05:45",
    "06:00",
    "06:15",
    "06:30",
    "06:45",
    "07:00",
    "07:15",
    "07:30",
    "07:45",
    "08:00",
  ];

  static durationHours = [
    '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'
  ];
  static durationMinutes = [
    '00', '15', '30', '45'
  ];

  static quarterArray(startHour:number, endHour:number){
    const quarterArray: string[] = [];
    let currentTime = new Date();
    currentTime.setHours(startHour,0,0,0);
    let amount = (endHour-startHour) * 4;
    for(var i = 0; i < amount + 1; i++) {
      const hour = currentTime.getHours().toString().padStart(2,'0');
      const minutes = currentTime.getMinutes().toString().padStart(2,'0');
      quarterArray.push(`${hour}:${minutes}`);
      currentTime.setHours(currentTime.getHours(), currentTime.getMinutes() + 15  )
    }
    return quarterArray
  }
  static getTimeUntilFutureDate(dateTime: string): TimeUntil | null {
    const futureDate = new Date(dateTime);
    const currentDate = new Date();
  
    if (futureDate <= currentDate) {
      return null;
    }
  
    const yearsDiff = futureDate.getFullYear() - currentDate.getFullYear();
    const monthsDiff = futureDate.getMonth() - currentDate.getMonth();
    const daysDiff = futureDate.getDate() - currentDate.getDate();
  
    let years = yearsDiff;
    let months = monthsDiff;
    let days = daysDiff;
  
    if (days < 0) {
      months--;
      const daysInLastMonth = new Date(futureDate.getFullYear(), futureDate.getMonth(), 0).getDate();
      days += daysInLastMonth;
    }
    if (months < 0) {
      years--;
      months += 12;
    }
  
    return {
      years: years,
      months: months,
      days: days
    };
  }

  static getTimeDifference(start:string, stop:string){
    let a = new Date(start);
    let b = new Date(stop);
    let diffInMilliseconds = Math.abs(a.getTime() - b.getTime());

    let hours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
    let minutes = Math.floor((diffInMilliseconds % (1000 * 60 * 60)) / (1000 * 60));

    return {
      hours: hours,
      minutes: minutes
    };
  }

  static getLocalizedTimeUntilString(translate: TranslateService, timeUntil: TimeUntil): string {
    if (!timeUntil) {
      return '';
    }
    let localizedString = translate.instant('Word.In(Time)') + ' ';
    if (timeUntil.years > 0) {
      localizedString += `${timeUntil.years} ${translate.instant('Word.Year' + (timeUntil.years > 1 ? 's' : '')).toLowerCase()}`;
      if (timeUntil.months > 0) {
        localizedString += `, ${timeUntil.months} ${translate.instant('Word.Month' + (timeUntil.months > 1 ? 's' : '')).toLowerCase()}`;
        if (timeUntil.days > 0) {
          localizedString += ` ${translate.instant('Word.And').toLowerCase()} ${timeUntil.days} ${translate.instant('Word.Day' + (timeUntil.days > 1 ? 's' : '')).toLowerCase()}`;
        }
      } else if (timeUntil.days > 0) {
        localizedString += ` ${translate.instant('Word.And').toLowerCase()} ${timeUntil.days} ${translate.instant('Word.Day' + (timeUntil.days > 1 ? 's' : '')).toLowerCase()}`;
      }
    } else if (timeUntil.months > 0) {
      localizedString += `${timeUntil.months} ${translate.instant('Word.Month' + (timeUntil.months > 1 ? 's' : '')).toLowerCase()}`;
      if (timeUntil.days > 0) {
        localizedString += ` ${translate.instant('Word.And').toLowerCase()} ${timeUntil.days} ${translate.instant('Word.Day' + (timeUntil.days > 1 ? 's' : '')).toLowerCase()}`;
      }
    } else {
      localizedString += `${timeUntil.days} ${translate.instant('Word.Day' + (timeUntil.days > 1 ? 's' : '')).toLowerCase()}`;
    }
    return '(' + localizedString + ')';
  }

  static getTimeSincePastDate(dateTime: string): TimeUntil | null {
    const pastDate = new Date(dateTime);
    const currentDate = new Date();
  
    if (pastDate >= currentDate) {
      return null;
    }
  
    const yearsDiff = currentDate.getFullYear() - pastDate.getFullYear();
    const monthsDiff = currentDate.getMonth() - pastDate.getMonth();
    const daysDiff = currentDate.getDate() - pastDate.getDate();
  
    let years = yearsDiff;
    let months = monthsDiff;
    let days = daysDiff;
  
    if (days < 0) {
      months--;
      const daysInLastMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0).getDate();
      days += daysInLastMonth;
    }
    if (months < 0) {
      years--;
      months += 12;
    }
  
    return {
      years: years,
      months: months,
      days: days
    };
  }

  static getLocalizedTimeSinceString(translate: TranslateService, timeSince: TimeUntil): string {
    if (!timeSince) {
      return '';
    }
    let localizedString = translate.instant('Word.Since') + ' ';
    if (timeSince.years > 0) {
      localizedString += `${timeSince.years} ${translate.instant('Word.Year' + (timeSince.years > 1 ? 's' : '')).toLowerCase()}`;
      if (timeSince.months > 0) {
        localizedString += `, ${timeSince.months} ${translate.instant('Word.Month' + (timeSince.months > 1 ? 's' : '')).toLowerCase()}`;
        if (timeSince.days > 0) {
          localizedString += ` ${translate.instant('Word.And').toLowerCase()} ${timeSince.days} ${translate.instant('Word.Day' + (timeSince.days > 1 ? 's' : '')).toLowerCase()}`;
        }
      } else if (timeSince.days > 0) {
        localizedString += ` ${translate.instant('Word.And').toLowerCase()} ${timeSince.days} ${translate.instant('Word.Day' + (timeSince.days > 1 ? 's' : '')).toLowerCase()}`;
      }
    } else if (timeSince.months > 0) {
      localizedString += `${timeSince.months} ${translate.instant('Word.Month' + (timeSince.months > 1 ? 's' : '')).toLowerCase()}`;
      if (timeSince.days > 0) {
        localizedString += ` ${translate.instant('Word.And').toLowerCase()} ${timeSince.days} ${translate.instant('Word.Day' + (timeSince.days > 1 ? 's' : '')).toLowerCase()}`;
      }
    } else {
      localizedString += `${timeSince.days} ${translate.instant('Word.Day' + (timeSince.days > 1 ? 's' : '')).toLowerCase()}`;
    }
    return '(' + localizedString + ')';
  }
  
}

export class Objectify {
  /**
   * 
   * @param data Any array that contains an 'id' key. All ids must be unique
   * @returns A dictionary with ids as keys
   */
  static arrayToDict(data:any[]){
    return Object.assign(
      {},
      ...data.map(({id,...rest}) => ({[id]:rest}) )
    )
  }

  static getObjectValueType(v:any){
    if(v == null) return null
    switch(typeof v){
      case 'object': return Array.isArray(v) ? 'array': 'object';
      default: return typeof v;
    }
  }

  /**
   * Sorts an array to fake a tree structure.
   * 
   * @param arr Any array with objects
   * @param id Dot notation variable
   * @param parentId Dot notation variable
   */
  static arrayToTree(arr:any[], id:string, parentId:string){
    var tree: any = [], mappedArr = {}, arrElem, mappedElem;
    let root = 'root';
    for (let x of arr) {
      arrElem = x;
      mappedArr[DeepRef.getValue(x, id)] = arrElem;
      mappedArr[DeepRef.getValue(x, id)]['children'] = [];
    }
    for (var folder in mappedArr) {
      if (mappedArr.hasOwnProperty(folder)) {
        mappedElem = mappedArr[folder];
        // If the element is not at the root level, add it to its parent array of children.
        if (!!DeepRef.getValue(mappedElem, parentId) && !!mappedArr[DeepRef.getValue(mappedElem, parentId)]) {
          mappedArr[DeepRef.getValue(mappedElem, parentId)]['children'].push(mappedElem);
        }
        // If the element is at the root level, add it to first level elements array.
        else tree.push(mappedElem);
      }
    };
    return tree;
  }

  static treeToTreeSortedArray(tree:any){
    let flatTree = [];
    tree.forEach(node => {
      flatTree.push(node);
      if (node.children) {
        flatTree = flatTree.concat(this.treeToTreeSortedArray(node.children));
      }
    });
  return flatTree;
  }

  static objectToKeyValueArray(obj: KeyValueObject): Array<{ key: string, value: any }> {
    return Object.entries(obj).map(([key, value]) => ({ key, value }));
  }

  static keyValueArrayToObject(arr: Array<{ key: string, value: any }>): KeyValueObject {
    return arr.reduce((obj: KeyValueObject, { key, value }) => {
      obj[key] = value;
      return obj;
    }, {});
  }
}

type KeyValueObject = { [key: string]: any };

export class Texts {
  static getCaretPosition():Selection{
    if (!document.getSelection) return null
    let selection = document.getSelection();
    return selection
  }
  static getCurrentLine():string{
    let s = Texts.getCaretPosition();
    if(!s) return ''
    return s.focusNode.textContent.slice(0,s.focusOffset + 2);
  }

  static toCamelCase(s:string):string {
    return s.replace(/[^a-zA-Z0-9 ]/g, '')
      .replace(/\s(.)/g, ($1) => $1.toUpperCase())
      .replace(/\s/g, '')
      .replace(/^(.)/, ($1) => $1.toLowerCase());
  }
}

export class Htmls {
  static elementHasChild(el:HTMLElement){
    if(!!el && !!el.children && Array.from(el.children).length > 0) return true
    return false
  }

  static getArrowKeyFromEvent(e:KeyboardEvent): string | null {
    if(e.key == 'ArrowLeft' || e.code == 'ArraowLeft') return 'left';
    else if(e.key == 'ArrowRight' || e.code == 'ArrowRight') return 'right';
    else if(e.key == 'ArrowUp' || e.code == 'ArrowUp') return 'up';
    else if(e.key == 'ArrowDown' || e.code == 'ArrowDown') return 'down';
    else return null
  }

  static closestParent(element:HTMLElement,type:'id'|'class'|'tag',s:string){
    switch(type){
      case 'class': return Htmls.findParentByClass(element, s)
      case 'id':{}
      case 'tag':{}
    }
  }

  static findParentByClass(el:HTMLElement, className:string):HTMLElement{
    if(!el.parentElement) return null;
    else if(el.parentElement.classList.contains(className)) return el.parentElement
    else return this.findParentByClass(el.parentElement, className)
  }

  static setStyle(el:HTMLElement,styleTarget:string, style ){
    el.style[styleTarget] = style;
  }

  static findParentWithId(el:HTMLElement){
    if(!!el.id) return el
    else return Htmls.findParentWithId(el.parentElement as HTMLElement)
  }

  static traceBranchFromDataset(data:HTMLElement, setName:string, stopDataset:string){
    let preIndices = '';
    let el = data;
    if(!el.dataset[stopDataset])  
    if(!data.dataset[setName]) while(!el.dataset[setName]) el = el.parentElement;
  }

  static findOffsetFromAncestor(el:HTMLElement, parentId:string, offsets){
    if(!el || el.tagName == 'BODY' || el.id == parentId) { 
      return offsets
    }
    else {
      offsets.push(
        {
          offLeft: el.offsetLeft,
          offTop: el.offsetTop,
          x: el.getBoundingClientRect().x,
          y: el.getBoundingClientRect().y,
          position: el.style.position,
          element: el
        }
      );
      return Htmls.findOffsetFromAncestor(el.parentElement,parentId, offsets)
    }
    while(el.tagName != 'BODY' && el.id != parentId){
      offsets.push(el.offsetLeft);
      el = el.parentElement as HTMLElement;
    }
    return offsets.reverse();
  }

  static boundsById(id:string):DOMRect{
    let e = document.getElementById(id) as HTMLElement;
    return e.getBoundingClientRect()
  }

  static removeAllChildren(e: HTMLElement, idNot?:string[]){
    Array.from(e.children).forEach(x => { if( !x.id || !!idNot && !idNot.includes(x.id)) e.removeChild(x)});
    return e
  }

  static styleStringToArray(s: string){
    return s.split(';').filter(x => !!x).map(x => {
      return {
        attribute: x.slice(0,x.indexOf(':')),
        value: x.slice(x.indexOf(':')+1).trim()
      }
    })
  }

  static selfSizingInput(e:Event){
    let t = e.target as HTMLInputElement;
    t.style.width = t.value.toString().length + 2 + 'ch';
  }

  static getBadge(text:string){
    if(!text) return 'Z'
    const lettersOnly = text.replace(/[^a-zA-Z]/g, '');
    return lettersOnly.charAt(0).toUpperCase();
  }
}

export class Mathy {
  static eval(expression:string | string[], scope:Object){ 
    return math.evaluate(expression, scope)
  }
  static parse(expression:string, scope:Object){math.parse(expression, scope) }
  static format(expression:string, scope:Object, precision:number){ math.format(this.eval(expression, scope), {notation:'fixed', precision:precision})}
  static getVariablesFromExpression(expression:string):string[]{
    return expression.split(/[^a-zA-Z.]+/).filter(Boolean);
  }

  /**
   * 
   * @param num an interger or float
   * @param language ISO language code (ie. 'da-DK')
   * @param currency ISO 4217 currency codes (ie. 'DKK')
   * @returns formatted currency string with currency abbreviation (ie. '1.000,00 kr.')
   */
  static currency(num:number, language:string, currency:string){
    return new Intl.NumberFormat(language, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
  }).format(num);
  }
  static numFormat(num:number, decimals:number, language:string){
    return new Intl.NumberFormat(language, { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num)
  }

  static bool(bool:boolean):number{ return bool == true ? 1 : 0  }

  static hexToHexDecimal(hex:string){
    let num = 0;
    for(let i = 0; i<hex.length;i++){
      num += parseInt(hex[i], 16) * (16 ** hex.length - (i + 1))
    }
    return num
  }

  static hexDecimalToHSL(hexDecimal:number, as:'array'|'json' = 'json'){
    let h = hexDecimal / 65536;
    let s = ((hexDecimal / 256) % 256) / 255;
    let l =  (hexDecimal % 256) / 255;
    return as == 'json' ? {h:h, s:s, l:l} : [h,s,l]
  }

  static tagTextColor(hex: string) {
    let hsl = this.hexDecimalToHSL(Mathy.hexToHexDecimal(hex.replace('#', ''))) as { h: number, s: number, l: number };
    if (!!hsl) return hsl.l < .55 ? 'black' : 'white';
    return 'black';
  }
}

export class Formats {
  static currency(val:string | number){
    return Intl.NumberFormat('da-DK', { style:'currency', currency:'DKK'}).format(+val)
  }
}

export interface TimeUntil {
  years: number,
  months: number,
  days: number
}